<script lang="ts">
  import type { VoiceParsed } from "../lib/api";
  import { haptic } from "../lib/tg";

  let {
    open = $bindable(false),
    parsed = null as VoiceParsed | null,
    onapply,
    onedit,
    oncancel,
  }: {
    open?: boolean;
    parsed?: VoiceParsed | null;
    onapply?: () => void;
    onedit?: () => void;
    oncancel?: () => void;
  } = $props();

  function close() {
    open = false;
  }
</script>

{#if open}
  <div class="backdrop" onclick={close} role="presentation"></div>
  <div class="sheet" role="dialog" aria-label="Подтверждение голосовой команды">
    <div class="grab"></div>
    <div class="title">Распознано</div>

    {#if parsed}
      <div class="summary">{parsed.summary}</div>
      {#if parsed.clarification_needed}
        <div class="clarify">Уточнение: {parsed.clarification_needed}</div>
      {/if}
      <div class="hint">Подсказка: называй ответственного («Ушаневу», «Тришину») и клиента/сделку («по Кристине», «Серебрякову»). Без имени — задача уходит на тебя.</div>
      <pre class="raw">{JSON.stringify(parsed.parsed, null, 2)}</pre>
    {:else}
      <div class="placeholder">Идёт распознавание…</div>
    {/if}

    <div class="actions">
      <button class="btn ghost" onclick={() => { haptic("light"); oncancel?.(); close(); }}>
        Отмена
      </button>
      <button class="btn ghost" onclick={() => { haptic("light"); onedit?.(); }}>
        Изменить
      </button>
      <button class="btn primary" onclick={() => { haptic("medium"); onapply?.(); close(); }}>
        Создать
      </button>
    </div>
  </div>
{/if}

<style>
  .backdrop {
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.5);
    z-index: 60;
    animation: fade 160ms ease;
  }
  .sheet {
    position: fixed;
    left: 0; right: 0; bottom: 0;
    background: var(--bg-elev);
    border-top-left-radius: 22px;
    border-top-right-radius: 22px;
    padding: 12px 18px calc(18px + var(--safe-bottom, 0px));
    box-shadow: var(--shadow-lg);
    z-index: 70;
    animation: slide 220ms cubic-bezier(.18,.89,.32,1.05);
    max-height: 80vh;
    overflow-y: auto;
  }
  .grab {
    width: 36px; height: 4px;
    background: var(--border-strong);
    border-radius: 2px;
    margin: 0 auto 12px;
  }
  .title {
    font-family: 'Manrope', sans-serif;
    font-weight: 700;
    font-size: 13px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--text-dim);
    margin-bottom: 8px;
  }
  .summary {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.4;
    margin-bottom: 12px;
    color: var(--text);
  }
  .placeholder {
    font-size: 14px;
    color: var(--text-mute);
    padding: 16px 0;
  }
  .clarify {
    font-size: 13px;
    color: var(--warning);
    background: var(--bg-elev-2);
    border: 1px solid var(--warning);
    border-radius: 10px;
    padding: 10px 12px;
    margin-bottom: 10px;
  }
  .hint {
    font-size: 11px;
    color: var(--text-dim);
    line-height: 1.45;
    margin-bottom: 12px;
    padding: 8px 10px;
    background: var(--bg-elev-2);
    border-radius: 8px;
  }
  .raw {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    color: var(--text-mute);
    background: var(--bg-elev-2);
    border: 1px solid var(--border);
    border-radius: 10px;
    padding: 10px 12px;
    overflow-x: auto;
    max-height: 200px;
  }
  .actions {
    display: grid;
    grid-template-columns: 1fr 1fr 1.4fr;
    gap: 8px;
    margin-top: 16px;
  }
  .btn {
    height: 46px;
    border-radius: 12px;
    font-family: 'Manrope', sans-serif;
    font-weight: 600;
    font-size: 14px;
    transition: filter 120ms;
  }
  .btn:active { filter: brightness(0.92); }
  .btn.ghost {
    background: var(--bg-elev-2);
    color: var(--text);
    border: 1px solid var(--border);
  }
  .btn.primary {
    background: var(--ember);
    color: #fff;
    box-shadow: var(--shadow-sm);
  }

  @keyframes fade { from { opacity: 0; } to { opacity: 1; } }
  @keyframes slide { from { transform: translateY(100%); } to { transform: translateY(0); } }
</style>
